import { apiClient } from '@/app/core/services/apiClient.service';
import { BaseApiService } from '@/app/shared/services/apis/baseApi.service';

export class AppConfigurationApiService extends BaseApiService {
    getFeatureFlags() {
        return this.client.get('feature-flags');
    }
}

export const appConfigurationApi = new AppConfigurationApiService(apiClient);
